/**
 * ClearHistorySection - Clear completed/cancelled tickets history
 */

import { Trash2 } from 'lucide-react';

interface ClearHistorySectionProps {
  clearingHistory: boolean;
  onClearHistory: () => void;
}

export function ClearHistorySection({ clearingHistory, onClearHistory }: ClearHistorySectionProps) {
  return (
    <div className="bg-surface border border-hairline rounded-xl p-6 mb-6">
      <div className="flex flex-col gap-4">
        <div>
          <h2 className="font-sans text-lg font-semibold text-ink mb-1">Historial de Turnos</h2>
          <p className="text-sm text-ink-muted">
            Elimina todos tus turnos completados y cancelados
          </p>
        </div>
        <button
          onClick={onClearHistory}
          disabled={clearingHistory}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-transparent border border-hairline text-danger rounded-lg hover:bg-danger/20 disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors w-full"
        >
          <Trash2 className="w-4 h-4" aria-hidden="true" />
          {clearingHistory ? 'Eliminando…' : 'Limpiar Historial'}
        </button>
      </div>
    </div>
  );
}
